import { useAuthListener } from './hooks/useAuth';
import { AppRouter } from './routes/AppRouter';
import { ToastHost } from './components/ToastHost';

export function App() {
  useAuthListener();
  return (
    <>
      <AppRouter />
      <ToastHost />
    </>
  );
}
